import { Server } from 'socket.io';
import { AuthSocket } from '../socket.bootstrap';
import { SocketEvents } from '@ichat/shared-types';

export function meetingHandler(io: Server, socket: AuthSocket) {
  // WebRTC Mesh Signaling for Meetings (Screen Share & Video)
  socket.on(SocketEvents.WEBRTC_OFFER, (data: { toUserId: string, roomId: string, offer: any }) => {
    if (!socket.permissions.includes('meeting_screen_share')) return;
    io.to(`user:${data.toUserId}`).emit(SocketEvents.WEBRTC_OFFER, {
      fromUserId: socket.userId,
      roomId: data.roomId,
      offer: data.offer,
      callerInfo: {
        id: socket.userId,
        displayName: socket.displayName
      }
    });
  });

  socket.on(SocketEvents.WEBRTC_ANSWER, (data: { toUserId: string, roomId: string, answer: any }) => {
    // Both sides need to accept
    io.to(`user:${data.toUserId}`).emit(SocketEvents.WEBRTC_ANSWER, {
      fromUserId: socket.userId,
      roomId: data.roomId,
      answer: data.answer
    });
  });

  socket.on(SocketEvents.WEBRTC_ICE_CANDIDATE, (data: { toUserId: string, roomId: string, candidate: any }) => {
    io.to(`user:${data.toUserId}`).emit(SocketEvents.WEBRTC_ICE_CANDIDATE, {
      fromUserId: socket.userId,
      roomId: data.roomId,
      candidate: data.candidate
    });
  });

  // Meeting State
  socket.on(SocketEvents.MEETING_START, (data: { roomId: string }) => {
    if (!socket.permissions.includes('meeting_whiteboard')) return;
    // Notify room that a meeting started
    io.to(data.roomId).emit(SocketEvents.MEETING_START, {
      roomId: data.roomId,
      startedBy: socket.userId,
      displayName: socket.displayName
    });
  });

  socket.on(SocketEvents.MEETING_JOIN, (data: { roomId: string }) => {
    if (!socket.permissions.includes('meeting_whiteboard')) return;
    io.to(data.roomId).emit(SocketEvents.MEETING_JOIN, {
      roomId: data.roomId,
      userId: socket.userId,
      displayName: socket.displayName
    });
  });

  socket.on(SocketEvents.MEETING_LEAVE, (data: { roomId: string }) => {
    io.to(data.roomId).emit(SocketEvents.MEETING_LEAVE, {
      roomId: data.roomId,
      userId: socket.userId,
      displayName: socket.displayName
    });
  });

  socket.on(SocketEvents.MEETING_END, (data: { roomId: string }) => {
    io.to(data.roomId).emit(SocketEvents.MEETING_END, {
      roomId: data.roomId,
      endedBy: socket.userId
    });
  });

  // Whiteboard Syncing
  socket.on(SocketEvents.WHITEBOARD_DRAW, (data: { roomId: string, drawingData: any }) => {
    if (!socket.permissions.includes('meeting_whiteboard')) return;
    // Broadcast to everyone in the room EXCEPT the sender
    socket.to(data.roomId).emit(SocketEvents.WHITEBOARD_DRAW, {
      roomId: data.roomId,
      userId: socket.userId,
      drawingData: data.drawingData
    });
  });

  socket.on(SocketEvents.WHITEBOARD_CLEAR, (data: { roomId: string }) => {
    if (!socket.permissions.includes('meeting_whiteboard')) return;
    socket.to(data.roomId).emit(SocketEvents.WHITEBOARD_CLEAR, {
      roomId: data.roomId,
      userId: socket.userId
    });
  });
}
